import { render, staticRenderFns } from "./DeleteButton.vue?vue&type=template&id=6e177033&scoped=true&"
var script = {}
import style0 from "./DeleteButton.vue?vue&type=style&index=0&id=6e177033&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e177033",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
